<!--&================= TITLE =================&-->
<div class="title-components">
  <h1>Visitas generales del sistema</h1>
</div>

<!--&================= CONTAINER BAR NAVIGATION =================&-->

<div class="Options-Menu">
  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-filter"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Filtro</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input Inputng-Select">
          <i class="fa-regular fa-circle-question"></i>
          <ng-select
            [searchable]="false"
            bindLabel="Name"
            [clearable]="false"
            (change)="Reload_Page()"
            [items]="Option_Type_Filter"
            [(ngModel)]="Select_Option_Type_Filter"
          >
          </ng-select>
          <i class="fa-solid fa-angle-down"></i>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER SELECT TYPE Finance =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="far fa-calendar-alt"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Periodo</h2>
      </div>

      <div class="Input-Option Container-Select-Type">
        <div class="Container-input calendar">
          <div class="calendar-container">
            <p-datepicker
              [(ngModel)]="StartDate"
              (ngModelChange)="Reload_Page()"
            ></p-datepicker>
          </div>
          <div class="separator">
            <i class="fa-solid fa-arrows-left-right"></i>
          </div>
          <div class="calendar-container">
            <p-datepicker
              [(ngModel)]="EndDate"
              (ngModelChange)="Reload_Page()"
            ></p-datepicker>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER INFORMATION =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fa-solid fa-gear"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="Option-Title">
        <h2>Actualizar información</h2>
      </div>

      <div class="Input-Option DisplayInputs">
        <!---================= CONTAINER RELOAD PAGE =================--->
        <div class="Container-Buttons">
          <button (click)="Reload_Page()" class="Btn-Option button-square">
            <span class="Tool-Tip">Recargar pagina</span>
            <i class="fa-solid fa-rotate-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!---================= CONTAINER INFORMATION =================--->
  <div class="Card-Option container-global-components">
    <div class="Icon-Left">
      <div class="Local-Icon-Card button-square">
        <i class="fas fa-hashtag"></i>
      </div>
    </div>

    <div class="Container-Card">
      <div class="information">
        <div class="option">
          <div class="Option-Title"><h2>Total de visitas</h2></div>
          <div class="Input-Option">{{ DataChartBar.total }}</div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="chart">
  <div class="chart__section chart__section--area" [class.day]="!(Select_Option_Type_Filter.Value === 4)">
    <div class="chart__area container-global-components">
      <app-large-chart-bar-cdms [DataChartBar]="DataChartBar" />
    </div>
    <div
      *ngIf="Select_Option_Type_Filter.Value === 4"
      class="chart__area container-global-components"
    >
      <app-simple-chart-pierc [DataChartPie]="DataChartPieAdmin"/>
    </div>
  </div>
</div>

<div *ngIf="!LoadPage" class="Container-Loader-Global active" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
